import React from 'react';
import IconBox from './IconBox'; // Import the IconBox component
import badminton from "../assets/image/badminton.svg";

const InterestedIn = () => {
  return (
    <div className="interested">
      <div className="interested-in">
        <IconBox color="#ffbb2c" icon="suitcase" title="Traveling" />
        <IconBox color="#e80368" icon="bicycle" title="Cycling" />
        <IconBox color="#e361ff" icon="paint-roller" title="Exploring" />
        <IconBox color="#5578ff" icon="chess-board" title="Chess" />
      </div>
      <div className="interested-in">
        <IconBox color="#29cc61" icon="fingerprint" title="Business" />
        <IconBox color="#11dbcf" icon="list" title="Cricket" />
        <IconBox color="#ff5828" icon="tower-broadcast" title="Web development" />
        <IconBox color="" icon="badminton" title="Badminton" badminton={badminton} />
      </div>
      <div className="interested-in">
        <IconBox color="#b2904f" icon="anchor" title="Problem solving" />
        <IconBox color="#2cfff7" icon="code" title="Coding" />
        <IconBox color="#0076CE" icon="database" title="Business" />
        <IconBox color="#47aeff" icon="chalkboard" title="Teaching" />
      </div>
    </div>
  );
};

export default InterestedIn;
